import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'cpd'})
export class CPD implements PipeTransform {
  transform(value: number): string {

    var hours = (value / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours+':'+rminutes;

  }
}